import { Checkpoint, Command, Config } from '@langchain/langgraph-sdk';

import { createContext } from 'react';

export const ContinueRefContext = createContext<
  React.MutableRefObject<
    ({
      checkpoint,
      command,
      config,
    }: {
      checkpoint: Checkpoint | string | undefined;
      command?: Command;
      config?: Config;
    }) => void
  >
>({ current: () => void 0 });
